import { render } from "./PasswordChangeForm.vue?vue&type=template&id=6e10e398&scoped=true"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=js"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=js"

import "./PasswordChangeForm.vue?vue&type=style&index=0&id=6e10e398&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e10e398"]])

export default __exports__